import { useToast } from '@lifebit-ai/lds'
import { UseQueryOptions, useQuery } from '@tanstack/react-query'

import { useOnQueryError } from 'hooks/useOnQueryError'
import { getResultsVerificationAssignees } from 'services/results'
import { ResultsQueryKeys } from 'services/results/queryKeys'
import type { GetResultsVerificationAssigneesResponse } from 'services/results/types'
import { ApiErrorResponse } from 'services/types'

export const useGetResultsVerificationAssignees = (
  options?: Omit<UseQueryOptions<GetResultsVerificationAssigneesResponse, ApiErrorResponse>, 'queryKey'>
) => {
  const toast = useToast()

  const query = useQuery<GetResultsVerificationAssigneesResponse, ApiErrorResponse>({
    ...options,
    queryKey: ResultsQueryKeys.ResultsVerificationAssignees(),
    queryFn: getResultsVerificationAssignees
  })

  useOnQueryError(query, () => {
    toast({ message: 'Failed to get results verification assignees', type: 'error' })
  })

  return query
}
